import {
  Button,
  Bullseye,
  Title,
  EmptyState,
  EmptyStateIcon,
  EmptyStateBody,
  EmptyStateSecondaryActions,
} from '@patternfly/react-core'
import { SearchIcon } from '@patternfly/react-icons'
import { TableComposable, TableVariant, Tbody } from '@patternfly/react-table'
import * as React from 'react'
import { useCallback } from 'react'

import type { ISorting } from '@app/lib/sorting'

import { PatientListHeader } from './patient-list-header'

interface Props {
  filtersInUse: boolean
  sorting: ISorting
  onClearAllFilters: () => void
}

export const EmptyPatientList = ({
  filtersInUse,
  sorting,
  onClearAllFilters,
}: Props) => {
  return (
    <>
      <TableComposable
        variant={TableVariant.compact}
        aria-label="Clinic Patients"
      >
        <PatientListHeader sorting={sorting} />
        <Tbody />
      </TableComposable>
      <Bullseye>
        <EmptyState>
          <EmptyStateIcon icon={SearchIcon} />
          <Title headingLevel="h5" size="lg">
            No results found
          </Title>
          {filtersInUse ? (
            <React.Fragment>
              <EmptyStateBody>
                No results match this filter criteria. Remove all filters or
                clear all filters to show results.
              </EmptyStateBody>
              <EmptyStateSecondaryActions>
                <Button variant="link" onClick={() => onClearAllFilters()}>
                  Clear all filters
                </Button>
              </EmptyStateSecondaryActions>
            </React.Fragment>
          ) : null}
        </EmptyState>
      </Bullseye>
    </>
  )
}
